import { Box, HStack, Image, Text, VStack } from "native-base";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import "./style.css";
import WebHeader from "../../../../layout/header/webHeader";
import { COLORS } from "../../../../utils/colors";
import Breadcrumbs from "../../../../components/breadcrumb";
import { useSelector } from "react-redux";

const WebLandingPageBanner = ({ openModal, show }) => {
  const location = useLocation();
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const eventTab = activeTab === "event" ? "Event" : "MICE";
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: { name: `${eventTab} Detail`, path: "/event-detail" },
    activeActivePage: { name: "", path: "" },
  };

  function bannerText() {
    return (
      <VStack>
        <Text
          fontSize={"54px"}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          pt={2}
        >
          Welcome to ABG
        </Text>
        <Text fontSize={"54px"} fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}>
          MICE & Events
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
        >
          This is a all in one platform where you can view all your events
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          pr={"12rem"}
          pt={2}
        >
          and MICE.
        </Text>
        <Text mt={4}></Text>
        {show && (
          <CustomButton
            onPress={() => {
              openModal();
            }}
            text="Raise Request"
            width="fit-content"
            py="10px"
          />
        )}
      </VStack>
    );
  }

  return (
    <Box bg={COLORS.WHITE_COLOR}>
      <Box pt={3} pb={1}>
        <WebHeader mt={0} />
      </Box>
      {location.pathname != "/home" && (
        <Box pb={2} pt={4} px={"5rem"}>
          <Breadcrumbs path={breadcrumbDetails} />
        </Box>
      )}
      <div className="landing-page-banner-container" p={"20px"}>
        <HStack flex={1} w="100%" h="100%">
          <Box w={"50%"} alignItems={"center"} justifyContent={"center"}>
            <Image
              source={{
                uri: require("../../../../utils/quickLinkImages/land-banner-1.png"),
              }}
              alt="image"
              width="400px"
              height="300px"
            />
          </Box>
          <Box w={"50%"} pt="1.5rem" pr={"50px"} pb={"3rem"}>
            {bannerText()}
          </Box>
        </HStack>
      </div>
    </Box>
  );
};

export default WebLandingPageBanner;
